import { getTestata } from '../lib/utils';

const testata = getTestata();
const premiumIconPath =
  testata === 'qn' ? '/static/img/paywall.svg' : '/static/img/paywall-blue.svg';

export const faqList = [
  {
    question: 'A che cosa ho accesso se mi abbono all’offerta “Abbonamento online”?',
    answer:
      'Se sottoscrivi l’offerta “Abbonamento online”, avrai libero accesso alle notizie online delle testate de il Resto del Carlino, LA NAZIONE, IL GIORNO, IL TELEGRAFO, quotidiano.net. Contenuti in esclusiva e vantaggi riservati ai membri della community. Newsletter giornaliera e aggiornamenti in tempo reale.',
  },
  {
    question: 'A che cosa ho accesso se mi abbono all’offerta “Sfoglia il giornale”?',
    answer:
      'Se sottoscrivi l’offerta “Sfoglia il giornale”, potrai consultare la versione sfogliabile del quotidiano direttamente sul tuo pc, smartphone e tablet, inoltre avrai libero accesso alle notizie online delle testate de il Resto del Carlino, LA NAZIONE, IL GIORNO, IL TELEGRAFO, Quotidiano.Net. Contenuti in esclusiva e vantaggi riservati ai membri della community. Newsletter giornaliera e aggiornamenti in tempo reale.',
  },
  {
    question: 'Come riconosco i contenuti premium?',
    answer:
      'i contenuti premium sono contraddistinti dall’icona <img src="' +
      premiumIconPath +
      '" /> e sono fruibili solo attraverso la registrazione o l’abbonamento al sito.',
  },
  {
    question: 'A che cosa ho accesso se mi registro?',
    answer:
      'Registrandoti avrai accesso ad ogni contenuto presente sulle edizioni di <a href="https://www.ilrestodelcarlino.it" target="_blank">ilrestodelcarlino.it</a>, <a href="https://www.lanazione.it" target="_blank">lanazione.it</a>, <a href="https://www.ilgiorno.it" target="_blank">ilgiorno.it</a>. Avrai accesso a 10 contenuti premium gratuiti al mese, terminati i quali sarà necessario abbonarsi. Riceverai inoltre ogni giorno, sulla tua casella di posta elettronica, tutte le principali notizie dell\'edizione scelta. Accedendo alla sezione newsletter nella tua pagina profilo potrai inoltre gestire il servizio, aggiungendo le ulteriori edizioni di tuo interesse.',
  },
  {
    question: 'Posso modificare i dati forniti in fase di registrazione?',
    answer:
      'Accedendo alla propria pagina profilo, è possibile modificare: Nome, Cognome, Data di nascita, Cap, Password. Non è possibile invece modificare il campo email. Per cambiare il proprio indirizzo email è necessario effettuare il logout dal proprio profilo e procedere ad una nuova registrazione, utilizzando quindi nuove credenziali.',
  },
  {
    question: 'Posso modificare i consensi alla privacy forniti in fase di registrazione?',
    answer:
      'Per revocare i consensi al trattamento dei dati forniti in fase di registrazione, è necessario scrivere a <a href="mailto:privacy@quotidiano.net">privacy@quotidiano.net</a>',
  },
  {
    question: 'Posso cancellare il mio profilo?',
    answer:
      'Sì, è possibile cancellare il profilo. Una volta terminata la procedura di cancellazione non sarà più possibile accedere ai contenuti riservati alla community. Per procedere è necessario cliccare sul link presente nella sezione “Impostazioni newsletter e account”.',
  },
  {
    question: 'Come posso disiscrivermi dal servizio di Newsletter e non ricevere quindi più mail?',
    answer:
      'Per disiscriversi autonomamente dalle Newsletter è sufficiente recarsi nella sezione “Impostazioni newsletter e account” e disattivare ciascuna iscrizione.',
  },
  {
    question: 'Da quando decorre l’attivazione dell’abbonamento?',
    answer:
      'L’abbonamento viene attivato automaticamente, una volta terminato il processo di acquisto nel caso di acquisto con carta di credito',
  },
  {
    question: 'Si può sospendere l’abbonamento e riattivarlo in un secondo momento?',
    answer:
      'Siamo spiacenti ma l’abbonamento ad QN Abbonamenti non prevede sospensioni in quanto, essendo un servizio Web, può essere consultato continuativamente',
  },
  {
    question: 'Quando acquisto un abbonamento, devo ricordarmi di rinnovare l’abbonamento?',
    answer:
      'Gli abbonamenti si rinnovano automaticamente, per cui alla scadenza il costo dell’abbonamento verrà addebitato in modo automatico.',
  },
  {
    question: 'Come posso disattivare il rinnovo automatico dell’abbonamento?',
    answer:
      'Accedi alla tua pagina profilo utilizzando le tue credenziali o la modalità di accesso tramite Facebook o Google che hai usato in fase di registrazione. Nella sezione “Abbonamenti e metodi di pagamento”, clicca sull’icona rossa in corrispondenza della “x” per cancellare il tuo abbonamento. Potrai continuare ad usufruire dei vantaggi dell’abbonamento fino alla scadenza dello stesso.',
  },
  {
    question: 'Non hai trovato l’aiuto che cercavi nelle precedenti domande?',
    answer:
      'Scrivi a <a href="mailto:sottoscrizioni@monrif.net">sottoscrizioni@monrif.net</a>, il nostro customer care è attivo dal lunedì al venerdì.',
  },
];

export const moreProductsList = [
  {
    title: 'il Resto del Carlino',
    text:
      'Abbonati a il Resto del Carlino e ricevi la copia cartacea del giornale comodamente a casa tua. Scopri tutte le modalità di consegna e le offerte dedicate ai nostri lettori',
    link:
      'https://abbonamenti-stampa.quotidiano.net/stampa/magazines/MRED/newsstand/purchase.html?mag=CARLINO',
  },
  {
    title: 'IL GIORNO',
    text:
      'Abbonati a IL GIORNO e ricevi la copia cartacea del giornale comodamente a casa tua. Scopri tutte le modalità di consegna e le offerte dedicate ai nostri lettori',
    link:
      'https://abbonamenti-stampa.quotidiano.net/stampa/magazines/MRED/newsstand/purchase.html?mag=GIORNO',
  },
  {
    title: 'LA NAZIONE',
    text:
      'Abbonati a LA NAZIONE e ricevi la copia cartacea del giornale comodamente a casa tua. Scopri tutte le modalità di consegna e le offerte dedicate ai nostri lettori',
    link:
      'https://abbonamenti-stampa.quotidiano.net/stampa/magazines/MRED/newsstand/purchase.html?mag=NAZIONE',
  },
];

export const offerTypeLabels = {
  message1: "Vuoi un'informazione senza limiti?",
  message2: "Scegli l'offerta che fa per te",
  product1: '',
  product2: 'Sfogliatore',
};

export const ctaLabels = {
  loading: 'Loading...',
  send: 'Invio...',
  confirm: 'Conferma',
};

export const userLabels = {
  loginToBuy: "Accedi per proseguire con l'acquisto",
  accedi: 'Accedi',
  alreadySubscribed: 'Gentile utente, risulta un abbonamento già attivo sull’indirizzo',
  backToHome: 'Continua a leggere',
  backToHomeAlternate: 'Torna alla Homepage',
};

export const recapLabels = {
  congrats: 'Grazie,',
  subscriptionIsActive: 'il tuo abbonamento è ora attivo!',
  yourChoice: 'La tua scelta',
  contentAvailability: 'Contenuti sempre disponibili su PC, tablet e smartphone',
  subscriptionType: 'Tipologia abbonamento',
  automaticRenew: 'Offerta a rinnovo automatico disattivabile in ogni momento',
  allOffers: 'Vedi tutte le offerte',
  clickHere: 'Continua a leggere',
  backToArticle: "per tornare all'articolo",
};

export const errorLabels = {
  nameNotValid: 'Il tuo Nome e Cognome non sono validi.',
  conditionsNotAccpted: 'È necessario accettare le condizioni generali del servizio.',
  generic: 'Si è verificato un errore, riprovare',
  genericAlternate: 'Si è verificato un errore.',
  contactCustomerSupport: "Si prega di riprovare o di contattare l'assistenza clienti.",
};
